export default __webpack_public_path__ + "static/media/admin_product_sales.fa519e1b.svg";